module.exports = __webpack_public_path__ + "static/GminaStezyca-a4ba41d0b27528d17850106b432bdcd7.svg";